import { combineReducers } from "redux";
import sessionState from "./Login/reducer";
import registrationReducer from "./Registartion/reducer";
import capacityReducer from "./Capacity/reducer";
import dashboardReducer from "./DashBoard/reducer";
import consumerCapacityReducer from "./ConsumerCapacity/reducer";
import notificationReducer from "./Notification/reducer";
import { buttonReducer } from "./ButtonFlag/reducer";
import listingsReducer from "./ListingsSearch/reducer"
import bankingCapacityReducer from "./Banking/reducer";
import analystReducer from "./Analyst/reducer";

const rootReducer = combineReducers({
    sessionState,
    registrationReducer,
    capacityReducer,
    dashboardReducer,
    consumerCapacityReducer,
    notificationReducer,
    buttonReducer,
    listingsReducer,
    bankingCapacityReducer,
    analystReducer
})

export default rootReducer;
